import moment from "moment";
import { ConnectionLog } from "./ConnectionInterface";


const getUserName = (inputString: string): string => {
  const matches = inputString.match(/_(.*?)_/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return inputString;
};

export const mapConnection = (connection: any): ConnectionLog => {
  const start = moment(connection.startDate);
  const end = moment(connection.endDate);

  return {
    id: connection.identifier,
    user: getUserName(connection.username),
    startDate: start.format("YYYY-MM-DD HH:mm"),
    endDate: end.format("YYYY-MM-DD HH:mm"),
    duration: moment.utc(end.diff(start)).format("H:mm:ss"),
    remoteHost: connection.remoteHost,
      viewEnabled: Object.keys(connection.logs || {}).length > 0,
    logs: connection.logs || {},
    identifier: connection.identifier,
  };
};
